<template>
  <main class="personnel">
    <div>
      <p>我们一起奋斗吧</p>
      <p>欢迎您的加入，成为翱锐家人，成为翱锐事业合伙人！</p>
    </div>
    <div>
      <p>用人理念</p>
      <p>激情勇气、公平公正、正直诚信、爱人爱己</p>
    </div>
    <div>
      <p>职业发展</p>
      <!-- <p>
        翱锐生物创立于2016年，是一家专注于肿瘤无创早筛和癌症精准诊断的国家高新技术企业
      </p>-->
      <!-- 两个小框 -->
      <div v-for="(item, index) in squre_2" :key="index">
        <div v-for="(sitem, sindex) in item.center" :key="sindex">
          <!-- <img srcrequire("../assets/image/rczx03.png") alt="" /> -->
          <img :src="sitem.img" alt />
          <p>{{ sitem.title }}</p>
        </div>

        <div>{{ item.buttom }}</div>
      </div>
    </div>
    <div class="main">
      <h1
        v-for="item in meanCenterObj._child"
        :key="item.id"
        @click="getList({ id: item.id })"
        :style="{ color: formData.id == item.id ? '#014198' : '#333' }"
      >{{ item.title }}</h1>
      <!-- <h1>校园招聘</h1> -->
      <!-- 搜索框 -->
      <div class="input">
        <input type="text" placeholder="请输入职位名称、类别、工作地点" clearable v-model="formData.keywords" />
        <div @click="getList">
          <i class="el-icon-search">职位搜索</i>
        </div>
      </div>
      <p>热门搜索：{{ JSON.parse(system.search_key).toString() }}</p>
      <!-- 表格 -->
      <transition name="el-zoom-in-center">
        <div v-show="show">
          <el-table
            v-if="!isApply"
            :data="tableData"
            v-bind="table"
            style="width: 100%"
            :header-cell-style="{
              'background-color': '#014198',
              'text-align': 'center',
              height: '3.33vw',
              'font-size': ' 0.93vw',
              color: '#fff',
            }"
            :cell-style="{
              'text-align': 'center',
              height: '3.33vw',
              'font-size': ' 0.93vw',
            }"
          >
            <el-table-column type="expand">
              <template slot-scope="props" :style="{ 'text-align': left }">
                <!-- <h1>职责描述</h1>
                <ol type="1">
                  <li>{{ props.row.description }}</li>
                </ol>
                <h1>任职要求</h1>-->
                <p v-html="props.row.content"></p>
                <!-- <ol type="1">
                <li>{{ props.row.content }}</li>
                </ol>-->
                <el-button class="button" @click="applyOne(true, props.row)">立即申请</el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-for="item in table.columns"
              :key="item.id"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
            <el-table-column label="简历投递">
              <template slot-scope="scope">
                <span class="span" @click="applyOne(true, scope.row)">立即申请</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="form">
            <el-button type="primiry" @click="applyOne(false)">返回列表</el-button>
            <!-- label-position="left" -->

            <el-form :model="formData" label-width="6.208vw" ref="formData">
              <div v-for="(item, index) of apply" :key="index">
                <el-form-item :label="item.label" :prop="item.prop" :rules="item.rules">
                  <el-input
                    :style="{
                      width:
                        ['resume', 'letter'].indexOf(item.prop) > -1
                          ? '53.83vw'
                          : '64.33vw',
                    }"
                    v-model="formData[item.prop]"
                  ></el-input>
                </el-form-item>
                <el-upload
                  v-if="['resume', 'letter'].indexOf(item.prop) > -1"
                  class="upload"
                  :action="$public_data.baseURL + '/index/upload/file'"
                  name="file"
                  :multiple="false"
                  :on-success="upSuccess"
                  :show-file-list="false"
                >
                  <el-button size="small" @click="upload(item.prop)">
                    上传
                    <span class="el-icon-document"></span>
                  </el-button>
                </el-upload>
              </div>
            </el-form>
            <el-button type="primiry" @click="applySure">提交</el-button>
          </div>
        </div>
      </transition>
    </div>
    <!-- 底部轮播 -->
    <div>
      <p>{{ pageCate.list[0].title }}</p>
      <div>
        <div id="carousel">
          <figure
            v-for="(item, index) in pageCate.list[0].images"
            :key="index"
            :style="{
              transform: `rotateY(${
                index * (360 / pageCate.list[0].images.length)
              }deg) translateZ(${
                ((pageCate.list[0].images.length * 100) / 1920) * 100
              }vw)`,
            }"
          >
            <el-image
              fit="contain"
              :src="item.image"
              :preview-src-list="
                pageCate.list[0].images.map((i) => {
                  return i.image;
                })
              "
            />
          </figure>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions, mapGettersns } from "vuex";
export default {
  name: "Personnel",
  data() {
    return {
      show: false,
      prop: "",
      apply: [
        {
          label: "姓名",
          prop: "name",
          rules: { required: true, message: "请输入姓名", trigger: "blur" },
        },
        {
          label: "邮箱",
          prop: "email",
          rules: [
            { required: true, message: "请输入邮箱地址", trigger: "blur" },
            {
              type: "email",
              message: "请输入正确的邮箱地址",
              trigger: ["blur", "change"],
            },
          ],
        },
        {
          label: "电话",
          prop: "phone",
          rules: [
            { required: true, message: "请输入办公电话", trigger: "blur" },
            {
              validator: function (rule, value, callback) {
                if (/^1[34578]\d{9}$/.test(value) == false) {
                  callback(new Error("请输入正确的手机号"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            },
          ],
        },
        {
          label: "简历",
          prop: "resume",
          rules: {
            required: true,
            message: "请上传简历附件",
            trigger: "change",
          },
        },
        {
          label: "求职信",
          prop: "letter",
          rules: {
            required: true,
            message: "请上传求职信附件",
            trigger: "change",
          },
        },
      ],
      // 搜索职位
      isApply: false,
      // 申请职位
      formData: {
        keywords: "",
        name: "",
        email: "",
        phone: "",
        resume: "",
        letter: "",
        cate_id: "",
      },
      squre_2: [
        {
          buttom: "管理职能",
          center: [
            {
              img: require("../assets/image/rczx01.png"),
              title: "主管",
            },
            {
              img: require("../assets/image/rczx02.png"),
              title: "经理",
            },
            {
              img: require("../assets/image/rczx03.png"),
              title: "总监",
            },
          ],
        },
        {
          buttom: "技术职能",
          center: [
            {
              img: require("../assets/image/rczx04.png"),
              title: "骨干",
            },
            {
              img: require("../assets/image/rczx05.png"),
              title: "专家",
            },
            {
              img: require("../assets/image/rczx06.png"),
              title: "资深专家",
            },
          ],
        },
      ],
      table: {
        columns: [
          { label: "职位名称", prop: "title" },
          { label: "职位类型", prop: "summary" },
          { label: "工作地点", prop: "city" },
          { label: "发布时间", prop: "create_time" },
          { label: "招聘人数", prop: "amount" },
        ],
        data: [],
        "show-header": true,
        size: "mini",
        stripe: true,
        border: true,
        type: "expand",
      },
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["pageCate", "meanCenterObj", "system"]),
  },
  created() {
    this.getCate({
      parent: this.meanCenterObj,
    });
    this.getList({ id: this.meanCenterObj._child[0].id });
  },
  methods: {
    ...mapActions(["getCate"]),
    // 上传
    upload(e) {
      this.prop = e;
    },
    upSuccess(res) {
      this.formData[this.prop] = res.data.file;
      console.log(res, this.formData, "文件上传");
    },
    // 更换类型
    getList(e) {
      this.show = false;
      if (e.id) {
        Object.assign(this.formData, { id: e.id });
      }
      this.$api.CATE(this.formData.id, this.formData).then((res) => {
        this.isApply = false;
        res.list.forEach((item) => {
          item.create_time = item.create_time.slice(0, 11);
        });
        // this.tableData.push(...res.list);
        this.tableData.splice(0, this.tableData.length, ...res.list);
        this.show = true;
      });
    },
    // 职位申请
    applyOne(type, e) {
      this.show = false;
      Object.assign(this.formData, { cate_id: type ? e.id : null });
      setTimeout(() => {
        this.show = true;
        this.isApply = type;
      }, 200);
    },
    // 确认申请
    applySure() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          this.$api.APPLY(this.formData).then((res) => {
            this.$message({
              type: "success",
              message: "已收到您的申请,请耐心等待",
            });
            this.$refs["formData"].resetFields();
            this.applyOne(false);
          });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
@import url("../assets/3d.css");
.el-button {
  width: 13.02vw;
  height: 3.9583vw;
  background: #1680d9;
  font-size: 1vw;
  margin-left: 64vw;
  border: 0.52vw solid #fff;
}

.el-input__inner {
  width: 190px;
  // height: 500px;
}
.personnel {
  > div {
    overflow: hidden;
    text-align: center;
    .span {
      color: #014198;
      font-size: 0.93vw;
      cursor: pointer;
    }
    > p:first-child {
      font-size: 2.4vw;
      font-weight: bold;
      margin-top: 6.7vw;
      margin-bottom: 5.1vw;
      + p {
        font-size: 1.56vw;
      }
    }
  }
  > div:nth-child(1) {
    > p {
      margin: 0;
    }
    height: 14.2vw;
    line-height: 6.77vw;
  }
  > div:nth-child(2) {
    width: 100vw;
    height: 53.33vw;
    background-image: url("../assets/image/rczxbg2.png");
  }
  > div:nth-child(3) {
    height: 46.4vw;
    background: url("../assets/image/rczxbg3.png") no-repeat;
    background-size: 50vw 100%;
    background-position-x: 50vw;
    p {
      margin-bottom: 2.08vw;
    }
    > p:first-child {
      margin-top: 3.1vw;
    }
    // 小框子
    > div {
      position: relative;
      width: 26.04vw;
      height: 29.427vw;
      box-shadow: 0px 0px 0.52vw 0.2604vw #eee;
      margin: 1vw;
      display: inline-block;
      background: #fff url("../assets/image/zhang@2x.png") no-repeat;
      background-size: 93% 40%;
      background-position: 20% 10%;
      > div {
        display: inline-block;
        position: absolute;
        img {
          width: 8.33vw;
          height: 8.33vw;
        }
      }
      > div:first-child {
        top: 15.104vw;
        left: 1.3025vw;
        + div {
          top: 10.41vw;
          left: 8.854vw;
          + div {
            top: 7.08vw;
            left: 17.2vw;
          }
        }
      }
      > div:last-child {
        bottom: 0;
        left: 0;
        font-size: 1.458vw;
        font-weight: bold;
        color: #fff;
        width: 100%;
        height: 3.9vw;
        line-height: 3.9vw;
        background: #014198;
      }
    }
  }
  > div:nth-child(4) {
    text-align: left;
    > h1 {
      font-size: 1.56vw;
      display: inline-block;
      margin-right: 2.1875vw;
      cursor: pointer;
    }
    > .input {
      display: flex;
      align-items: center;
      // justify-content: center;
      height: 3.33vw !important;
      border: 1px solid #014198;
      background: #014198;
      margin: 2.08vw auto 1vw;
      input {
        border: none;
        height: 3.229vw !important;
        flex: 0 0 80%;
        padding-left: 1vw;
        font-size: 0.73vw;
      }
      > div {
        font-size: 1vw;
        color: #fff;
        flex: 0 0 20%;
        text-align: center;
      }
      + p {
        font-size: 0.73vw;
        color: #ccc;
        margin-left: 2.08vw;
        margin-bottom: 2.08vw;
      }
    }
    .el-button {
      background: #014198;
      color: #fff;
      height: 3.1vw;
      padding: 0;
      margin: 0;
    }
    > div {
      > .form {
        width: 77.7vw;
        min-height: 29.79vw;
        background: #eeeeee;
        padding-bottom: 2.083vw;
        > .el-button {
          border-color: #014198;
        }
        > .el-button:first-child {
          font-size: 0.93vw;
          width: 7.291vw;
          height: 2.08vw;
          border-radius: 0 1.04vw 1.04vw 0;
          margin-left: -0.5208vw;
          margin-top: 2.08vw;
        }
        > .el-button:last-child {
          font-size: 1vw;
          display: block;
          width: 26.04vw;
          height: 3.33vw;
          // padding: 1.56vw 0;
          margin: 0 auto !important;
        }
        > .el-form {
          // width: 63.541vw;
          width: 77.6vw;
          margin: 0 auto 3.125vw;
          > div {
            position: relative;
            height: 5.33vw;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-form-item {
              margin: 0 auto;
              margin-left: 5.208vw;
            }
            input {
              height: 3.33vw !important;
              // background-color: #f00;
            }
            .el-button {
              position: absolute;
              font-size: 0.93vw;
              bottom: 1.3vw;
              right: 3vw;
              width: 8.41vw;
              margin: 0;
              height: 3vw;
              border: none;
              background-color: #fff;
              color: #014198;
            }
          }
          // .el-input {
          // width: 58.3vw;
          // }
        }
      }
    }
  }
  > div:last-child {
    height: 41.77vw;
    .el-image {
      width: 41.97vw;
      height: 21.875vw;
    }
  }
}
.me-cell {
  text-align: center;
  height: 3.33vw;
  font-size: 0.93vw;
}
</style>


// WEBPACK FOOTER //
// src/views/Personnel.vue